import React, {useState} from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Stack
} from '@mui/material';
import {useDispatch, useSelector} from 'react-redux';
import {createContact} from '../actions/contacts/contacts';
import {useToken} from '../hooks/useToken';
import {useMsal} from "@azure/msal-react";

const CreateContactModal = ({open, onClose}) => {
    const [formData, setFormData] = useState({
        firstName: '',
        secondName: '',
        lastName: '',
        phoneNumber: ''
    });
    
    const {id_customer} = useSelector(state => state.agent);
    const dispatch = useDispatch();
    const {instance} = useMsal();
    const {tokenRequest} = useToken();

    const handleChange = (field) => (event) => {
        setFormData({
            ...formData,
            [field]: event.target.value
        });
    };

    const handleSubmit = () => {
        if (formData.phoneNumber && formData.firstName) {
            instance.acquireTokenSilent(tokenRequest)
                .then(({accessToken}) => {
                    dispatch(createContact(id_customer, formData, accessToken));
                    handleClose();
                });
        }
    };

    const handleClose = () => {
        setFormData({
            firstName: '',
            secondName: '',
            lastName: '',
            phoneNumber: ''
        });
        onClose();
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>Agregar Nuevo Contacto</DialogTitle>
            <DialogContent>
                <Stack spacing={2} sx={{mt: 1}}>
                    <TextField
                        label="Nombre *"
                        value={formData.firstName}
                        onChange={handleChange('firstName')}
                        fullWidth
                        required
                    />
                    <TextField
                        label="Segundo Nombre"
                        value={formData.secondName}
                        onChange={handleChange('secondName')}
                        fullWidth
                    />
                    <TextField
                        label="Apellido"
                        value={formData.lastName}
                        onChange={handleChange('lastName')}
                        fullWidth
                    />
                    <TextField
                        label="Teléfono *"
                        value={formData.phoneNumber}
                        onChange={handleChange('phoneNumber')}
                        fullWidth
                        required
                        type="tel"
                    />
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancelar</Button>
                <Button 
                    onClick={handleSubmit} 
                    variant="contained"
                    disabled={!formData.firstName || !formData.phoneNumber}
                >
                    Crear Contacto
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CreateContactModal;
